export default __webpack_public_path__ + "static/compact-8ea1c2c1863aac0bd84bf380170f7797.png";